import script from "./RequestPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestPage.vue?vue&type=script&setup=true&lang=js"

import "./RequestPage.vue?vue&type=style&index=0&id=15fdfb42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15fdfb42"]])

export default __exports__